import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const Research = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">📚 Research</h1>
          <p className="text-muted-foreground">saved articles, experiments, AI/tech research</p>
        </div>
      </StaggeredAnimation>

      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Research Dashboard</CardTitle>
            <CardDescription>saved articles, experiments, AI/tech research</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">Research content will be displayed here...</p>
          </CardContent>
        </Card>
      </StaggeredAnimation>
    </div>
  );
};

export default Research;